export default function NotFound404Page() {
  return (
    <div>
      <h1>404</h1>
      <p>That page was not found!</p>
    </div>
  );
}
